import { render, staticRenderFns } from "./CollectionReceiptDialog.vue?vue&type=template&id=3f150c63"
import script from "./CollectionReceiptDialog.vue?vue&type=script&lang=js"
export * from "./CollectionReceiptDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports